/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerminalDto } from './TerminalDto';
import {
    TerminalDtoFromJSON,
    TerminalDtoFromJSONTyped,
    TerminalDtoToJSON,
    TerminalDtoToJSONTyped,
} from './TerminalDto';

/**
 * 
 * @export
 * @interface PageTerminalDto
 */
export interface PageTerminalDto {
    /**
     * 
     * @type {number}
     * @memberof PageTerminalDto
     */
    currentPageNo: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTerminalDto
     */
    isFirst: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTerminalDto
     */
    isLast: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {Array<TerminalDto>}
     * @memberof PageTerminalDto
     */
    pageContent: Array<TerminalDto>;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalDto
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalDto
     */
    totalPages?: number | null;
}

/**
 * Check if a given object implements the PageTerminalDto interface.
 */
export function instanceOfPageTerminalDto(value: object): value is PageTerminalDto {
    if (!('currentPageNo' in value) || value['currentPageNo'] === undefined) return false;
    if (!('isFirst' in value) || value['isFirst'] === undefined) return false;
    if (!('isLast' in value) || value['isLast'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('pageContent' in value) || value['pageContent'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    return true;
}

export function PageTerminalDtoFromJSON(json: any): PageTerminalDto {
    return PageTerminalDtoFromJSONTyped(json, false);
}

export function PageTerminalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageTerminalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPageNo': json['currentPageNo'],
        'isFirst': json['isFirst'],
        'isLast': json['isLast'],
        'numberOfElements': json['numberOfElements'],
        'pageContent': ((json['pageContent'] as Array<any>).map(TerminalDtoFromJSON)),
        'pageSize': json['pageSize'],
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'] === undefined ? undefined : json['totalPages'] === null ? null : json['totalPages'],
    };
}

export function PageTerminalDtoToJSON(json: any): PageTerminalDto {
    return PageTerminalDtoToJSONTyped(json, false);
}

export function PageTerminalDtoToJSONTyped(value?: PageTerminalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPageNo': value['currentPageNo'],
        'isFirst': value['isFirst'],
        'isLast': value['isLast'],
        'numberOfElements': value['numberOfElements'],
        'pageContent': ((value['pageContent'] as Array<any>).map(TerminalDtoToJSON)),
        'pageSize': value['pageSize'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

